module.exports = "/images/user-add-red.svg?edc219f9938732c37e65db34b0716510";